import { render, staticRenderFns } from "./PermissionSettings.vue?vue&type=template&id=061e7500&"
import script from "./PermissionSettings.vue?vue&type=script&lang=js&"
export * from "./PermissionSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports